import React, { useEffect, useState, useContext } from "react";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";
import organisms from "../../../../components/organisms";
import service from "../../../../api/services";
import {
  BASE_URL,
  Default_Page_Limit,
} from "../../../../constants/defaultValues";
import { useToasts } from "react-toast-notifications";

import { HeaderHeading } from "../../../../Context";
import { ModifiedDataProps, OrderReadyDataProps } from "./interface";
import constant from "../../../../constants/constant";
import { paginationFunction } from "./hook/usePagination";

const { OrderReady } = organisms;
const { handleSearch, handlePaginationAction } =
  paginationFunction();

const Index = () => {
  const { addToast } = useToasts();
  const { setHeader }: any = useContext(HeaderHeading);
  const [search, setSearch] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState(Default_Page_Limit);
  const [allocationAllData, setAllocationAllData] = useState<
    OrderReadyDataProps[]
  >([]);
  const [allocationPartialData, setAllocationPartialData] = useState<
    OrderReadyDataProps[]
  >([]);
  const [storeAllocationList, setStoreAllocationList] = useState<
    ModifiedDataProps | any
  >();

  const getFilterList = async () => {
    try {
      const response = await service.fittingLab.orderReadyList({
        search: search,
        page: currentPage,
        limit: limit,
      });

      if (response.status === 200) {
        setAllocationAllData(response?.data?.data || []);
        setAllocationPartialData(response?.data?.data || []);
        handlePaginationAction({
          data: response?.data?.data,
          limit: limit,
          page: currentPage,
          setStoreAllocationList: (value: ModifiedDataProps) =>
            setStoreAllocationList(value),
        });
      }
    } catch (error: any) {
      console.error(error)
      addToast(error.response.data.message, {
          appearance: 'error',
          autoDismiss: true,
          autoDismissTimeout: 3000,
      });
  }
  };

  const handlePrintSharePdf = async (id: string) => {
    try {
      let response;
      response = await service.fittingLab.generateOrderForm(id);
      if (response.status === 200) {
        let path = response?.data?.data?.path;
        let fullPath = `${BASE_URL}${path}`;
        let cleanPAth = fullPath.replace(/api\/\.\//, "");
        let fileName = cleanPAth.substring(cleanPAth.lastIndexOf("/") + 1);

        setTimeout(() => {
          fetch(`${cleanPAth}`).then((response) => {
            response.blob().then((blob) => {
              // Creating new object of PDF file
              const fileURL = window.URL.createObjectURL(blob);

              // Setting various property values
              let alink = document.createElement("a");
              alink.href = fileURL;
              alink.download = `${fileName}`;
              alink.click();
            });
          });
        }, 2000);
      }
    } catch (error: any) {
      console.error("error", error);
      addToast(error?.data?.message, {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 3000,
      });
    }
  };

  const handleReadyOrder = async (id: string) => {
    try {
      let response = await service.fittingLab.updateOrderStatus(id, {
        order_status: constant.ORDER_STATUS.PENDING,
      });
      if (response.status === 200) {
        addToast(response?.data?.message, {
          appearance: "success",
          autoDismiss: true,
          autoDismissTimeout: 3000,
        });
        getFilterList();
      }
    } catch (error: any) {
      console.error("error", error);
      addToast(error?.data?.message, {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 3000,
      });
    }
  };

  useEffect(() => {
    setHeader("Fitting Lab - Order Ready");
    getFilterList();
  }, []);

  return (
    <Wrapper>
      <div>
        <OrderReady
          receiptData={storeAllocationList}
          setSearch={(value:string)=>handleSearch({
            value,
            data:allocationAllData,
            setCurrentPage,
            setLimitPerPage:setLimit,
            setStoreAllocationList,
            setAllocationPartialData,
          })}
          limit={limit}
          currentPage={currentPage}
          setLimitPerPage={(limitPerPage: number) => {
            setLimit(limitPerPage);
            setCurrentPage(1);
            handlePaginationAction({
              data: allocationPartialData,
              limit: limitPerPage,
              page: 1,
              setStoreAllocationList: (value: ModifiedDataProps) =>
                setStoreAllocationList(value),
            });
          }}
          setCurrentPage={(page: number) => {
            setCurrentPage(page);
            handlePaginationAction({
              data: allocationPartialData,
              limit: limit,
              page: page,
              setStoreAllocationList: (value: ModifiedDataProps) =>
                setStoreAllocationList(value),
            });
          }}
          handlePrintSharePdf={(id: string) => handlePrintSharePdf(id)}
          handleReadyOrder={(id: string) => handleReadyOrder(id)}
        />
      </div>
    </Wrapper>
  );
};

export default Index;
